import { Component, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-achievement',
  templateUrl: './achievement.component.html',
  styleUrls: ['./achievement.component.scss']
})
export class AchievementComponent implements OnInit {
  imgUrl:string[]=[
    // '/assets/img/showcase/1.jpeg',
    '/assets/img/showcase/2.jpeg',
    '/assets/img/showcase/3.jpeg',
    '/assets/img/showcase/4.jpeg',
  ]
  constructor() { }

  ngOnInit(): void {
    $('#firstCarousel').carousel({
      interval: 4000
    })
  }

}
